module.exports = __webpack_public_path__ + "img/kakutoku.70cfa2ba.png";